import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, ActivatedRoute, Router } from '@angular/router';
import { TokenService } from 'app/token/token.service';
import { ApplicationService } from './application/application.service';
import { Token } from './token/token';

@Injectable()
export class RedirectResolveService implements Resolve<any> {
    constructor(private route: ActivatedRoute, private tokenService: TokenService, private applicationService: ApplicationService, private router: Router) { }
    resolve(route: ActivatedRouteSnapshot) {
        return new Promise((resolve, reject) => {
            this.tokenService.removeOnlyToken();
            this.route.queryParams.subscribe(queryParams => {
                const encryptedToken = queryParams.params;
                if (encryptedToken) {
                    if (this.tokenService.getUTSEncryptedTokenCache(encryptedToken)) {
                        // Setting manual delay to allow back button navigation.
                        setTimeout(() => {
                            resolve('checkout flow');
                            return;
                        }, 1000);

                    } else {
                        this.applicationService.getDecryptedToken(queryParams.params).subscribe(res => {
                            const tokenResponse = res.token;
                            const tokenResponseJson = JSON.parse(tokenResponse);
                            if (tokenResponse && (Object.keys(tokenResponseJson).length > 1)) {
                                this.tokenService.setCheckoutParams(tokenResponseJson);
                                  if (tokenResponseJson.access_token) {
                                    const token = new Token(tokenResponseJson.access_token);
                                    this.tokenService.saveToSession(token);
                                    // this.tokenService.setMixPanelUserId();
                                    this.router.navigate(['/loggedinredirect']);
                                } else {
                                    // Can save the encrypted token alone to cache.
                                    this.tokenService.setUTSEncryptedTokenCache(encryptedToken);
                                }
                                resolve('checkout flow');
                            } else {
                                this.tokenService.setCheckoutParams(null);
                                const token = new Token(tokenResponse);
                                this.tokenService.saveToSession(token);
                                setTimeout(() => {
                                    this.router.navigate(['/loggedinredirect']);
                                }, 500);
                                resolve('GC flow');
                            }
                        } , error => {
                            this.tokenService.setCheckoutParams(null);
                            this.applicationService.sendDataToLogger('UTS Token decryption failed', {
                                token: queryParams.params,
                                errorMessage: error ? error.message : 'NA'
                            }).subscribe();
                            resolve(null);
                        });
                    }
                } else {
                    resolve(null);
                }
            });
        });
    }
}
